class FreeGoodies extends HTMLElement {
  constructor() {
    super();
    this.giftModal = this.querySelector("gift-modal");
    this.popup = this.giftModal ? this.giftModal.querySelector(".goodies-popup") : this.querySelector(".goodies-popup");
    this.openPopup = this.querySelector(".js-open-goodie-popup");
    this.closePopup = this.querySelectorAll(".js-close-goodie-popup");
    this.addToCartButtons = this.querySelectorAll(".product-card--add-to-cart-button-simple");
    this.popupOverlay = this.giftModal ? this.giftModal.querySelector(".goodies-overlay") : this.querySelector(".goodies-overlay");

    this.isInDrawer = this.hasAttribute("rendered-in-drawer");
    this.cartDrawer = document.getElementById("CartDrawer");
  }

  get freeGoodieReached () {
    return this.hasAttribute('data-active');
  }

  get goodieInCart() {
    return this.hasAttribute('data-goodie-in-cart-id') ? this.getAttribute('data-goodie-in-cart-id') : undefined;
  }

  connectedCallback() {
    if (!this.isInDrawer && !this.hasAttribute('data-moved-popup-to-body')) {
      if (this.giftModal) {
        document.body.appendChild(this.giftModal);
      } else {
        if (this.popup) {
          document.body.appendChild(this.popup);
        }
        if (this.popupOverlay) {
          document.body.appendChild(this.popupOverlay);
        }
      }
      this.setAttribute('data-moved-popup-to-body', 'true');
    }
    this.watchGoodiesProgress();
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('line-item:change:start', (event)=> {
      if(event.detail.quantity === '0' && event.detail.line_id === this.goodieInCart) {
        this.removeDiscountCode();
      }
    })
    if (this.openPopup) {
      this.openPopup.addEventListener('click', (event)=> this.openPopupHandler(event));
      this.closePopup.forEach(button => {
        button.addEventListener('click', (event)=> this.closePopupHandler(event));
      });
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click',  async (event)=> this.addGoodieToCart(button, event));
      })
      document.addEventListener('keyup', (event)=> this.handleKeyUp(event));
    } else {
      document.removeEventListener('keyup', (event)=> this.handleKeyUp(event));
    }
  }

  openPopupHandler(event) {
    event.preventDefault();
    if (this.giftModal?.show) {
      this.giftModal.show(this.openPopup);
      return;
    }
    this.popup?.classList.add('active');
    this.popupOverlay?.classList.add('active');
  }

  closePopupHandler(event) {
    event.preventDefault();
    if (this.giftModal?.hide) {
      this.giftModal.hide(true);
      return;
    }
    this.popup?.classList.remove('active');
    this.popupOverlay?.classList.remove('active');
  }

  handleKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode === 'ESCAPE') {
      if (this.giftModal?.hide) {
        this.giftModal.hide(true);
        return;
      }
      this.closePopupHandler(event);
    }
  }

  async watchGoodiesProgress() {
    if (!this.freeGoodieReached && this.goodieInCart) {
        await this.removeDiscountCode();
        await this.removeGoodieFromCart(this.goodieInCart); 
    }
  }
  
  async applyDiscount(code) {
    try {
      await fetch(`${window.Shopify.routes.root}discount/${code}`);
    } catch (error) {
      console.error("error applying discount", error);
    }
  }

  async removeDiscountCode() {
    try {
      await fetch(`${window.Shopify.routes.root}discount/CLEAR`);
    } catch (error) {
      console.error('Failed to clear discount:', error);
    }
  }

  async addGoodieToCart(button, event) {
    event.preventDefault();
    const code = button.dataset.code;
    const id = button.dataset.productId;

    if(this.goodieInCart) {
      await this.removeDiscountCode();
      await this.removeGoodieFromCart(this.goodieInCart); 
    }
    if (!code && !id) return;

    button.classList.add("loading");
    button.setAttribute("aria-disabled", true);
    if (this.giftModal?.hide) {
      this.giftModal.hide(false);
    } else {
      this.popup?.classList.remove("active");
      this.popupOverlay?.classList.remove("active");
    }

    const url = `${window.Shopify.routes.root}cart/add.js`;
    const bodyRequest = {
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            _gift_product: true
          }
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.section || section.id),
      sections_url: window.location.pathname
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyRequest)
    };

    try {
      if(this.isInDrawer) {       
         this.cartDrawer.classList.add("loading");
      }

      await this.applyDiscount(code);
      const response = await fetch(url, config);
      const result = await response.json();
      
   
      this.renderContents(result);
    

      button.classList.remove("loading");
      button.removeAttribute("aria-disabled");

    } catch (error) {
      console.error(error);
    } finally {
      if (this.isInDrawer) {
        this.cartDrawer.classList.remove("loading");
      }
    }
  }

  async removeGoodieFromCart(id) {
    const url = `${window.Shopify.routes.root}cart/update.js`;
    const bodyRequest = {
      updates: {
        [id]: 0
      },
      sections: this.getSectionsToRender().map((section) => section.section || section.id),
      sections_url: window.location.pathname
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyRequest)
    };

    try {
        if(this.isInDrawer) {       
         this.cartDrawer.classList.add("loading");
      }
      const response = await fetch(url, config);
      const result = await response.json();
      this.renderContents(result);

       if (this.isInDrawer) {
        this.cartDrawer.classList.remove("loading");
      }
      
      const cartDrawer = document.getElementById('CartDrawer');
      if (cartDrawer) {
        if (result.item_count === 0) {
          console.log("test");
          cartDrawer.classList.add('is-empty');
        } else {
          cartDrawer.classList.remove('is-empty');
        }
      }
      const mainCart = document.getElementById('MainCartItems');
      if (mainCart) {
        if (result.item_count === 0) {
          mainCart.classList.add('is-empty');
        } else {
          mainCart.classList.remove('is-empty');
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  getSectionsToRender() {
    return [
      this.isInDrawer
        ? {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".cart-drawer"
    }
        : {
            id: "MainCartItems",
            section: "main-cart-items",
            selector: ".cart__contents",
          },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-drawer',
        section: 'cart-icon-bubble-drawer',
        selector: '.shopify-section',
      },
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) {
        return;
      }
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      if (typeof Cart !== 'undefined') {
        new CartItems().renderContents(parsedState);
      }
    }));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

if(!customElements.get('free-goodies')) {
  customElements.define('free-goodies', FreeGoodies)
}